import { render, staticRenderFns } from "./StockLine.vue?vue&type=template&id=5e83e57d&scoped=true&"
import script from "./StockLine.vue?vue&type=script&lang=js&"
export * from "./StockLine.vue?vue&type=script&lang=js&"
import style0 from "./StockLine.vue?vue&type=style&index=0&id=5e83e57d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e83e57d",
  null
  
)

export default component.exports